import "./EditPartnerSettings.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditPartnerSettingsComponentController from "./EditPartnerSettingsComponentController";

export default class EditPartnerSettingsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditPartnerSettingsComponentController;
        this.templateUrl = "/App/Components/Partners/Details/EditPartnerSettings/EditPartnerSettings.html";
    }
}

module("mmManagePortal").component("irEditPartnerSettings", new EditPartnerSettingsComponent());
